(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  if (!customElements.get('ns-search-results')) {
    class NsSearchResults extends HTMLElement {
      connectedCallback() {
        if (this.initialised) return;
        this.initialised = true;
        this.boundClick = this.handleClick.bind(this);
        this.boundWishlistSync = this.syncWishlist.bind(this);
        this.addEventListener('click', this.boundClick);
        window.addEventListener('ns:wishlist:update', this.boundWishlistSync);
        window.addEventListener('storage', this.boundWishlistSync);
        this.syncWishlist();
        this.loadTaggedCodeMatches();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.boundClick);
        window.removeEventListener('ns:wishlist:update', this.boundWishlistSync);
        window.removeEventListener('storage', this.boundWishlistSync);
      }

      getWishlist() {
        try {
          const stored = JSON.parse(window.localStorage.getItem('ns_wishlist') || '[]');
          return Array.isArray(stored) ? stored.map(String) : [];
        } catch (error) {
          return [];
        }
      }

      setWishlist(list) {
        const normalised = list.map(String).filter((id, index, values) => id && values.indexOf(id) === index);
        try {
          window.localStorage.setItem('ns_wishlist', JSON.stringify(normalised));
        } catch (error) {}
        window.dispatchEvent(new CustomEvent('ns:wishlist:update', {
          detail: { ids: normalised.slice(), count: normalised.length }
        }));
      }

      syncWishlist() {
        const wishlist = this.getWishlist();
        this.querySelectorAll('[data-ns-search-wishlist]').forEach((button) => {
          const active = wishlist.includes(String(button.dataset.nsSearchWishlist || ''));
          button.classList.toggle('is-wished', active);
          button.setAttribute('aria-pressed', String(active));
          const card = button.closest('[data-ns-search-product-card]');
          const title = card ? card.dataset.productTitle : '';
          const label = active ? this.dataset.wishlistRemoveText : this.dataset.wishlistAddText;
          button.setAttribute('aria-label', `${label}: ${title}`);
        });
      }

      async loadTaggedCodeMatches() {
        const code = (this.dataset.nsCodeQuery || '').trim();
        // Only attempt an exact catalogue-code tag lookup after native search misses.
        if (!/^NS[A-Z0-9]{3,18}$/i.test(code)) return;
        const emptyMessage = this.querySelector('.ns-search__empty');
        if (!emptyMessage) return;

        const taggedUrl = new URL(`${this.dataset.nsTagCollectionUrl}/${code.toLowerCase()}`, window.location.origin);
        const previewThemeId = new URLSearchParams(window.location.search).get('preview_theme_id');
        if (previewThemeId) taggedUrl.searchParams.set('preview_theme_id', previewThemeId);
        const sectionUrl = new URL(taggedUrl);
        sectionUrl.searchParams.set('section_id', 'ns-tag-search-results');

        try {
          const response = await fetch(sectionUrl, { credentials: 'same-origin' });
          // Unknown tags redirect to /collections/all. Never show unrelated products.
          if (!response.ok || new URL(response.url).pathname !== taggedUrl.pathname) return;
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          const matches = documentFragment.querySelector('[data-ns-tag-search-results]');
          const count = Number(matches && matches.dataset.nsTagMatchCount);
          if (!this.isConnected || !matches || !Number.isSafeInteger(count) || count < 1) return;

          const viewAll = matches.querySelector('[data-ns-tag-view-all]');
          if (viewAll) viewAll.href = taggedUrl.href;
          emptyMessage.replaceWith(matches);
          const countLabel = `${count} product${count === 1 ? '' : 's'} tagged “${code.toUpperCase()}”`;
          const summary = this.querySelector('.ns-search__summary');
          const toolbarCount = this.querySelector('.utility-bar__centre .utility-bar__item');
          if (summary) summary.textContent = countLabel;
          if (toolbarCount) toolbarCount.textContent = countLabel;
          document.title = document.title.replace(/\b0 results? found\b/i, `${count} result${count === 1 ? '' : 's'} found`);
          this.syncWishlist();
        } catch (error) {
          // Preserve Shopify's normal no-results state if the optional lookup fails.
        }
      }

      handleClick(event) {
        const wishlistButton = event.target.closest('[data-ns-search-wishlist]');
        if (wishlistButton && this.contains(wishlistButton)) {
          event.preventDefault();
          event.stopPropagation();
          const productId = String(wishlistButton.dataset.nsSearchWishlist || '');
          if (!productId) return;
          const wishlist = this.getWishlist();
          const nextWishlist = wishlist.includes(productId)
            ? wishlist.filter((id) => id !== productId)
            : wishlist.concat(productId);
          this.setWishlist(nextWishlist);
          return;
        }

        const addButton = event.target.closest('[data-ns-search-quick-add]');
        if (!addButton || !this.contains(addButton)) return;
        event.preventDefault();
        this.quickAdd(addButton);
      }

      async quickAdd(button) {
        if (button.disabled || button.dataset.busy === 'true') return;
        const variantId = Number(button.dataset.nsSearchQuickAdd || 0);
        if (!variantId) return;

        const originalText = button.dataset.originalText || button.textContent.trim();
        const card = button.closest('[data-ns-search-product-card]');
        const status = card ? card.querySelector('[data-ns-search-card-status]') : null;
        button.dataset.originalText = originalText;
        button.dataset.busy = 'true';
        button.disabled = true;
        button.textContent = this.dataset.addingText;
        if (status) status.textContent = this.dataset.addingText;

        try {
          const response = await fetch(this.dataset.cartAddUrl, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          });
          if (!response.ok) throw new Error('cart-add-failed');

          button.textContent = this.dataset.addedText;
          if (status) status.textContent = this.dataset.addedText;
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          const drawer = document.querySelector('.js-cart-drawer');
          const cartForm = drawer ? drawer.querySelector('cart-form') : null;
          if (cartForm && typeof cartForm.refresh === 'function') cartForm.refresh();
          if (drawer && typeof drawer.open === 'function') drawer.open(button);

          window.setTimeout(() => {
            if (!button.isConnected) return;
            button.textContent = originalText;
            button.disabled = false;
            button.dataset.busy = 'false';
          }, 1800);
        } catch (error) {
          button.textContent = this.dataset.errorText;
          if (status) status.textContent = this.dataset.errorText;
          button.disabled = false;
          button.dataset.busy = 'false';
          window.setTimeout(() => {
            if (!button.isConnected || button.dataset.busy === 'true') return;
            button.textContent = originalText;
          }, 2200);
        }
      }
    }

    customElements.define('ns-search-results', NsSearchResults);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
